import { ApolloError } from '@apollo/client';

import { getGraphQlErrorMessage } from './getGraphQlErrorMessage';

export const extractMessageFromUnknownError = (error: unknown): string => {
  if (error instanceof ApolloError) {
    return getGraphQlErrorMessage(error);
  }
  if (error instanceof Error) {
    return error.message;
  }
  return String(error);
};
